<div [ngClass]="!(profileState | async).loader['audit']['followerEngage'] ? 'background-loader' : ''">
  <div>
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['followerEngage']"></div>
    <h3 class="card-header">
      Engage by week days
<!--      <a data-tooltip="Tooltip text">-->
<!--        <img class="icon-info" src="./assets/images/icons/info.png" />-->
<!--      </a>-->
    </h3>
    <div class="m--margin-top-20" *ngIf="chartsFollowerEngage !== undefined">
      <div [chart]="chartsFollowerEngage[0]"></div>
    </div>
  </div>
</div>
